<template>
    <div class="user">
        <div class="search">
            <Button type="primary" class="add_user" icon="md-add" @click="show_add_manager = true">{{$t('add')}}{{$t('new_manager')}}</Button>
        </div>
        <Table border :columns="columns12" :data="managerList">
            <template slot-scope="{ row }" slot="is_open">
                <Tag color="green" v-if="row.is_open==1">{{$t('coin.already')}}{{$t('coin.open')}}</Tag>
                <Tag color="red" v-else>{{$t('coin.already')}}{{$t('coin.off')}}</Tag>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <div class="op_btn">
                    <Button
                        type="info"
                        size="small"
                        style="margin-right: 5px"
                        @click="showManagerDetail(row.id)"
                    >{{$t('coin.edit')}}</Button>
                    <Button
                        v-if="row.is_open == 0"
                        type="success"
                        size="small"
                        style="margin-right: 5px"
                        @click="openModal(row)"
                    >{{$t('coin.open')}}</Button>
                    <Button
                        v-if="row.is_open == 1"
                        type="warning"
                        size="small"
                        style="margin-right: 5px"
                        @click="openModal(row)"
                    >{{$t('coin.off')}}</Button>
                    <!--Button
                        type="error"
                        size="small"
                        style="margin-right: 5px"
                        @click="showDelManager(row)"
                    >{{$t('announcement.del')}}</Button-->
                </div>
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
        <Modal v-model="show_add_manager" :title="$t('add')+$t('new_manager')" @on-ok="add_manager">
            <Form :model="modalAdd" :label-width="100">
                <Form :model="modalAdd" :label-width="100">
                  <FormItem :label="$t('cn')">
                      <Input type="text" v-model="modalAdd.tag_cn"></Input>
                  </FormItem>
                  <FormItem :label="$t('en')">
                      <Input type="text" v-model="modalAdd.tag_en"></Input>
                  </FormItem>
                  <FormItem :label="$t('lao')">
                      <Input type="text" v-model="modalAdd.tag_lao"></Input>
                  </FormItem>
                  <FormItem :label="$t('manager.is_open')">
                      <Select v-model="modalAdd.is_open">
                          <Option value="1">{{$t('coin.open')}}</Option>
                          <Option value="0">{{$t('coin.off')}}</Option>
                      </Select>
                  </FormItem>
                </Form>
            </Form>
        </Modal>

        <Modal
            v-model="showOkModal"
            :title="$t('coin.confirmOk')"
            @on-ok="change_staust(1)"
            @on-cancel="showOkModal=false"
        >
        </Modal>
        <Modal
            v-model="showCancelModal"
            :title="$t('coin.confirmCancel')"
            @on-ok="change_staust(0)"
            @on-cancel="showCancelModal=false"
        >
        </Modal>
        <Modal
            v-model="showDelModal"
            :title="$t('confirmDel')"
            @on-ok="delManager();"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>
    </div>
</template>


<script>
export default {
    data() {
        return {
            modalItem: {},
            showDelModal: false,
            currentPage: 1,
            totalItems: 0,
            totalPages: 1,
            totalItems: 1,
            itemsPerPage: 10,
            showOkModal: false,
            showCancelModal: false,
            search:{
                status:''
            },
            columns12: [
                {
                    title: "ID",
                    width: 80,
                    key: "id"
                },
                {
                    title: this.$i18n.t('cn'),
                    width: 200,
                    key: "tag_cn"
                },
                {
                    title: this.$i18n.t('en'),
                    width: 200,
                    key: "tag_en"
                },
                {
                    title: this.$i18n.t('lao'),
                    width: 200,
                    key: "tag_lao"
                },
                {
                    title: this.$i18n.t('is_open'),
                    width: 200,
                    key: "is_open",
                    slot: "is_open"
                },
                {
                    title: this.$i18n.t('action'),
                    slot: "action",
                    width: 200,
                    align: "center",
                    fixed:"right"
                }
            ],
            managerList: [],
            modalAdd: {
                id: 0,
                tag_cn: "",
                tag_en: "",
                tag_lao: "",
                is_open: "1"
            },
            show_add_manager: false,
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            let query = Object.assign({"page":this.currentPage},{
                status: this.search.status,
                page: this.currentPage
            });
            this.$get(this.$path.tag_info, query).then(res => {
                if (res.data) {
                    this.managerList = res.data;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        openModal(row) {
          this.modalItem = row;
          if(this.modalItem.is_open == 1){
            this.showCancelModal = true;
          }else{
            this.showOkModal = true;
          }
        },
        change_staust(status) {
          this.$post(this.$path.change_tag_info, {
              id: this.modalItem.id,
              status: status
          }).then(res => {
              if (res.success) {
                  this.$Message.success(this.$i18n.t('operateSuccess'));
                  this.loadData(this.currentPage);
              }
          });
        },
        showDelManager(row) {
          this.modalItem = row;
          this.showDelModal = true;
        },
        delManager() {
          this.$post(this.$path.del_manager, {
              id: this.modalItem.id
          }).then(res => {
              if (res.success) {
                  this.$Message.success(this.$i18n.t('operateSuccess'));
                  this.loadData(this.currentPage);
                  this.modalAdd = {id:0, tag_cn: "", tag_en:"", tag_lao:"", is_open:""};
              }
          });
        },
        showManagerDetail(id){
          for(let ann of this.managerList){
            if(ann.id == id){
              this.modalAdd.id = ann.id;
              this.modalAdd.tag_cn = ann.tag_cn;
              this.modalAdd.tag_en = ann.tag_en;
              this.modalAdd.tag_lao = ann.tag_lao;
              this.modalAdd.is_open = ann.is_open.toString();
              this.show_add_manager = true;
              break;
            }
          }
        },
        add_manager() {
            if(this.modalAdd.tag_cn == ""){
              this.$Message.success(this.$i18n.t('manager.span2'));
              return;
            }
            if(this.modalAdd.tag_en == ""){
              this.$Message.success(this.$i18n.t('manager.span3'));
              return;
            }
            if(this.modalAdd.tag_lao == ""){
              this.$Message.success(this.$i18n.t('manager.span4'));
              return;
            }
            this.$post(this.$path.add_tag_info, this.modalAdd).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                    this.modalAdd = {
                        tag_cn: "",
                        tag_en: "",
                        tag_lao: "",
                        is_open: ""
                    }
                }
            });
        },
    }
};
</script>


<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.card-image {
  width: 100%;
  border-radius: 7px;
}

.upload-area {
  width: 100px;
  height: 100px;
  background: #f8f9fa;
  border: 2px dashed #ccc;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
}

.upload-placeholder {
  text-align: center;
  color: #999;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.plus-icon {
  font-size: 20px;
  line-height: 20px;
}

.image-section{
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/user.vue